import Ayisha from "../assets/team/ayisha.png"
import Bhagyaj from "../assets/team/bhagyaj.png"
import Treesa from "../assets/team/treesa.png"
import Govind from "../assets/team/govind.png"
import Arnav from "../assets/team/arnav.png"
import Aiswarya from "../assets/team/aiswarya.png"


const teamMembers = [
    {
        "name": "Ayisha Hanna",
        "photo": Ayisha,
        "title": "Campus Lead"
    },
    {
        "name": "Bhagyaj Kumar",
        "photo": Bhagyaj,
        "title": "Tech Lead"
    },
    {
        "name": "Treesa George",
        "photo": Treesa,
        "title": "WIT Lead"
    },
    {
        "name": "Govind R Nair",
        "photo": Govind,
        "title": "Program Facilitator"
    },
    {
        "name": "Arnav Kashyap",
        "photo": Arnav,
        "title": "Program Facilitator",
    },
    {
        "name": "Aiswarya",
        "photo": Aiswarya,
        "title": "Media Lead"
    }
]

export default teamMembers